<template>
  <div class="table-show">
    <el-table :header-cell-style="{background:'rgb(250, 250, 250)'}" :data="tableData" style="width: 100%"
              :row-style="{ height: '65px' }" v-loading="loading" element-loading-text="Loading...">
      <el-table-column prop="materialCode" :label="$t('ApplyAfterSales.materialCode')"></el-table-column>
      <el-table-column prop="SN" label="SN"></el-table-column>
      <el-table-column prop="SNLabel" label="SN Label">
        <template v-slot="scope">
          <el-button v-if="scope.row.SNLabel" link @click="showSNLabel(scope.row)"><span
              class="link-text-style">{{ $t('ApplyAfterSales.view') }}</span></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="invoice" :label="$t('ApplyAfterSales.invoice')">
        <template v-slot="scope">
          <el-button v-if="scope.row.invoice" link @click="showInvoice(scope.row)"><span
              class="link-text-style">{{ $t('ApplyAfterSales.view') }}</span></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="defectCategory" :label="$t('ApplyAfterSales.defectiveCategory')"
                       :formatter="formatDefectCategory"></el-table-column>

      <el-table-column :label="$t('ApplyAfterSales.defectivePicture')" prop="defectImages" :width="200">
        <template v-slot="scope">
          <el-button v-if="scope.row.defectImages" link @click="showDefectImage(scope.row)"><span
              class="link-text-style">{{ $t('ApplyAfterSales.view') }}</span></el-button>
        </template>
      </el-table-column>

      <el-table-column prop="defectVideos" :label="$t('ApplyAfterSales.defectiveVideo')">
        <template v-slot="scope">
          <el-button v-if="scope.row.defectVideos" link @click="showVideo(scope.row)"><span
              class="link-text-style">{{ $t('ApplyAfterSales.view') }}</span></el-button>
        </template>
      </el-table-column>

      <el-table-column prop="defectDescription" :label="$t('ApplyAfterSales.defectiveDescription')" :width="200"></el-table-column>
      <el-table-column :label="$t('ApplyAfterSales.operation')" v-if="showOperationColumn">
        <template v-slot="scope">
          <el-button link @click="editItem(scope.row)"><span
              class="link-text-style">{{ $t('ApplyAfterSales.edit') }}</span></el-button>

          <el-popconfirm :title="$t('ApplyAfterSales.WhetherToDelete')" placement="top" @confirm="deleteItem(scope.row)"
                         :confirm-button-text="$t('ApplyAfterSales.ok')"
                         :cancel-button-text="$t('ApplyAfterSales.cancel')"
                         confirm-button-type="success"
                         width="250"
          >
            <template #reference>
              <el-button link><span class="link-text-delete">{{ $t('ApplyAfterSales.delete') }}</span></el-button>
            </template>
          </el-popconfirm>

        </template>
      </el-table-column>
      <template v-slot:empty>
        <EmptySlot/>
      </template>
    </el-table>

    <!-- 弹窗，用于展示视频 -->
    <el-dialog v-model="videoDialogVisible" @open="disableScroll" @close="enableScroll" :title="`视频 ${currentVideoIndex + 1}/${defectVideos.length}`">
      <div style="display: flex; align-items: center; justify-content: center;">
        <el-button 
          v-if="defectVideos.length > 1 && currentVideoIndex > 0" 
          @click="showPreviousVideo"
          circle
          style="margin-right: 10px;"
        >
          <el-icon><ArrowLeft /></el-icon>
        </el-button>
        
        <video v-if="currentVideoUrl" ref="videoPlayer" controls autoplay style="max-width: 80%; max-height: 500px;"
        >
          <source :src="currentVideoUrl" type="video/mp4">
          {{ $t('ApplyAfterSales.browserNotSupportVideoTag') }}
        </video>
        
        <el-button 
          v-if="defectVideos.length > 1 && currentVideoIndex < defectVideos.length - 1" 
          @click="showNextVideo"
          circle
          style="margin-left: 10px;"
        >
          <el-icon><ArrowRight /></el-icon>
        </el-button>
      </div>
      <div style="margin-top: 10px; text-align: center;">
        <el-button @click="downloadFile(currentVideoUrl, `video_${currentVideoIndex + 1}.mp4`)" v-if="currentVideoUrl">{{ $t('ApplyAfterSales.download') }}</el-button>
      </div>
    </el-dialog>


    <el-dialog v-model="showImageDialog" @open="disableScroll" @close="enableScroll">
      <img :src="imageUrl" alt="SN Label" style="max-width: 100%; max-height: 100%;">
      <div style="margin-top: 10px; text-align: center;">
        <el-button @click="downloadFile(imageUrl, 'sn_label.png')">{{ $t('ApplyAfterSales.download') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog v-model="invoiceVisible" width="30%">
      <img :src="invoiceUrl" alt="SN Label" style="max-width: 100%; max-height: 100%;">
      <div style="margin-top: 10px; text-align: center;">
        <el-button @click="downloadFile(invoiceUrl, 'invoice.png')">{{ $t('ApplyAfterSales.download') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog v-model="defectImageVisible" width="80%" :title="`图片 ${currentImageIndex + 1}/${defectImages.length}`">
      <div style="display: flex; align-items: center; justify-content: center;">
        <el-button 
          v-if="defectImages.length > 1 && currentImageIndex > 0" 
          @click="showPreviousImage"
          circle
          style="margin-right: 10px;"
        >
          <el-icon><ArrowLeft /></el-icon>
        </el-button>
        
        <div style="max-width: 80%; max-height: 600px; display: flex; justify-content: center; align-items: center;">
          <img :src="defectImageUrl" alt="缺陷图片" style="max-width: 100%; max-height: 600px; object-fit: contain;">
        </div>
        
        <el-button 
          v-if="defectImages.length > 1 && currentImageIndex < defectImages.length - 1" 
          @click="showNextImage"
          circle
          style="margin-left: 10px;"
        >
          <el-icon><ArrowRight /></el-icon>
        </el-button>
      </div>
      <div style="margin-top: 10px; text-align: center;">
        <el-button @click="downloadFile(defectImageUrl, `defect_image_${currentImageIndex + 1}.png`)" v-if="defectImageUrl">{{ $t('ApplyAfterSales.download') }}</el-button>
      </div>
    </el-dialog>

    <!-- 故障信息编辑弹框 -->
    <el-dialog v-model="faultDialogVisible" :title="$t('ApplyAfterSales.edit')" style="text-align: left;"
               @open="disableScroll" @close="handleDialogClose"
               width="1200">
      <!-- 弹框内容 -->
      <el-form ref="form" :model="formData" :rules="formRules" label-position="top">
        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item :label=" $t('ApplyAfterSales.materialCode')" prop="materialCode">
              <template #label>
                <span>{{ $t('ApplyAfterSales.materialCode') }}</span>
                <el-tooltip effect="dark">
                  <template v-slot:content>
                    <img :src="snMaterialCodeUrl" alt="Tooltip Image" class="resized-image">
                  </template>
                  <el-icon class="custom-tooltip-icon">
                    <QuestionIcon/>
                  </el-icon>
                </el-tooltip>
              </template>
              <el-input v-model="formData.materialCode"
                        :placeholder="$t('ApplyAfterSales.materialCodePlaceholder')"
                        class="custom-input-width"
                        :rules="formRules.materialCode">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="SN">
              <template #label>
                <span>SN</span>
                <el-tooltip effect="dark">
                  <template v-slot:content>
                    <img :src="snImgUrl" alt="Tooltip Image" class="resized-image">
                  </template>
                  <el-icon class="custom-tooltip-icon">
                    <QuestionIcon/>
                  </el-icon>
                </el-tooltip>
              </template>
              <el-input v-model="formData.SN" :placeholder="$t('ApplyAfterSales.sNPlaceholder')" :rules="formRules.SN"
                        class="custom-input-width"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item label="SN Label" prop="SNFileList" :rules="formRules.SNFileList">
              <el-upload v-model:file-list="formData.SNFileList" class="upload-demo"
                         :before-upload="handleBeforeUploadSN"
                         :limit="1" accept="image/*">
                <el-button class="upload-button">
                  <el-icon>
                    <Upload/>
                  </el-icon>
                  {{ $t('ApplyAfterSales.UploadAttachment') }}
                </el-button>

              </el-upload>
            </el-form-item>

          </el-col>

          <el-col :span="12">

            <el-form-item :label="$t('ApplyAfterSales.invoice')" prop="invoiceFileList">
              <!-- 上传附件的代码，可以使用 el-upload -->
              <el-upload v-model:file-list="formData.invoiceFileList" class="upload-demo"
                         :before-upload="handleBeforeUploadInvoice"
                         :limit="1" accept="image/*"
              >
                <el-button class="upload-button">
                  <el-icon>
                    <Upload/>
                  </el-icon>
                  {{ $t('ApplyAfterSales.UploadAttachment') }}
                </el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item :label=" $t('ApplyAfterSales.defectiveCategory')" prop="defectCategory">

              <el-tree-select
                  v-model="formData.defectCategory"
                  :data="defectCategoryOptions"
                  :props="{ label: 'label', children: 'children' }"
                  :style="{ width: selectWidth }"
                  :show-checkbox="false"
                  :placeholder="$t('ApplyAfterSales.defectiveCategoryPlaceholder')"
                  :render-after-expand="false"
                  clearable filterable
                  class="custom-input-width"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">

            <el-form-item :label=" $t('ApplyAfterSales.motorAppearance')" prop="motorAppearance"
                          class="custom-radio-group"
                          :rules="formRules.motorAppearance">
              <el-radio-group v-model="formData.motorAppearance">
                <el-radio :label="1"> {{ $t('ApplyAfterSales.good') }}</el-radio>
                <el-radio :label="0"> {{ $t('ApplyAfterSales.abnormal') }}</el-radio>
                <!-- 添加更多选项 -->
              </el-radio-group>
            </el-form-item>

          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label=" $t('ApplyAfterSales.defectivePicture')" prop="imageFileList">
              <!-- 上传附件的代码，可以使用 el-upload -->
              <el-upload v-model:file-list="formData.imageFileList" class="upload-demo"
                         :before-upload="handleBeforeUploadImg"
                         accept="image/*"
              >
                <el-button class="upload-button">
                  <el-icon>
                    <Upload/>
                  </el-icon>
                  {{ $t('ApplyAfterSales.UploadImage') }}
                </el-button>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="12">

            <el-form-item :label="$t('ApplyAfterSales.defectiveVideo')" prop="videoFileList">

              <el-upload v-model:file-list="formData.videoFileList" class="upload-demo"
                         :before-upload="handleBeforeUploadVideo"
                         accept="video/*"
              >
                <el-button class="upload-button">
                  <el-icon>
                    <Upload/>
                  </el-icon>
                  {{ $t('ApplyAfterSales.UploadAttachment') }}
                </el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('ApplyAfterSales.defectiveDescription')" prop="defectDescription">
              <el-input type="textarea" v-model="formData.defectDescription" :rules="formRules.defectDescription"
                        rows="2"
                        :placeholder="$t('ApplyAfterSales.defectiveDescriptionPlaceholder')" clearable></el-input>
            </el-form-item>

          </el-col>
        </el-row>

        <!-- 按钮区域 -->
        <div class="dialog-footer" style="margin-top: 20px;">
          <el-button @click="closeFaultDialog" class="custom-reset-button"> {{ $t('ApplyAfterSales.cancel') }}
          </el-button>
          <el-button class="button-background-color" @click="validateBeforeSave" :loading="isUploading"> {{ $t('ApplyAfterSales.ok') }}
          </el-button>
        </div>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import {deleteAfterSalesDetails,
  //getDefectCategorysData,
  showAfterSalesDetails, updateAfterSalesDetails, uploadFileData, getSignUrl,
} from "@/api/api";
import {Upload, ArrowLeft, ArrowRight} from "@element-plus/icons-vue";
import dialogMixin from '@/mixins/dialogMixin';
import QuestionIcon from "@/components/QuestionIcon.vue";
import EmptySlot from "@/components/EmptySlot.vue";

export default {
  components: {EmptySlot, QuestionIcon, Upload, ArrowLeft, ArrowRight},
  mixins: [dialogMixin],
  props: {
    loadData: {
      type: Function,
    },
    tableData: {
      type: Array,
      required: true, // 如果从父组件未传递 tableData，会发出警告
    },
    loading: Boolean, // 加载状态
    showOperationColumn: Boolean, // 加载状态
  },

  data() {
    return {
      invoiceVisible: false,
      defectImageVisible: false,
      snMaterialCodeUrl: require('@/assets/sn-materialcode.png'),
      snImgUrl: require('@/assets/sn.jpg'),
      deleteDialogVisible: false,
      deleteIndex: null,
      faultDialogVisible: false,
      formData: {
        materialCode: '',
        SN: '',
        defectDescription: '',
        SNFileList: [], // 用于存储上传的文件列表
        SNUploadedFile: '',
        videoFileList: [],
        videoUploadedFiles: '', // 用于存储多个视频的key，逗号分隔
        video_names: [], // 用于存储视频名称
        invoiceFileList: [],
        invoiceUploadedFile: '',
        imageFileList: [],
        imgUploadedFiles: '', // 用于存储多个图片的key，逗号分隔
        image_names: [], // 用于存储图片名称
        defectCategory: [], // 存储选择的不良类别
        motorAppearance: '',
        // 添加其他字段的初始值
      },
      formRules: {
        materialCode: [{required: true, message: this.$t('ApplyAfterSales.enterMaterialCode'), trigger: 'blur'}],
        SN: [{required: true, message: this.$t('ApplyAfterSales.enterSN'), trigger: 'blur'}],
        SNFileList: [{required: true, message: this.$t('ApplyAfterSales.uploadSNLabel'), trigger: 'blur'}],
        invoiceFileList: [{required: true, message: this.$t('ApplyAfterSales.uploadInvoice'), trigger: 'blur'}],
        defectCategory: [{required: true, message: this.$t('ApplyAfterSales.selectDefectiveCategory'), trigger: 'change'}],
        motorAppearance: [{required: true, message: this.$t('ApplyAfterSales.checkMotorAppearance'), trigger: 'blur'}],
        defectDescription: [{
          required: true,
          message: this.$t('ApplyAfterSales.enterDefectDescription'),
          trigger: 'blur'
        }],
        imageFileList: [{required: true, message: this.$t('ApplyAfterSales.uploadDefectivePicture'), trigger: 'blur'}],
        videoFileList: [{required: true, message: this.$t('ApplyAfterSales.uploadDefectiveVideo'), trigger: 'blur'}],
      },
      cascadeProps: {
        value: 'value', // 值字段
        label: 'label', // 显示的文本字段
        children: 'children' // 子选项字段
      },
      defectCategoryOptions: [],

          showImageDialog: false,
        imageUrl: '',
        videoDialogVisible: false,
        currentVideoUrl: '',
        invoiceUrl: '',
        defectImageUrl: '',
        defectImages: [], // 存储多个图片的URL
        currentImageIndex: 0, // 当前图片索引
        defectVideos: [], // 存储多个视频的URL
        currentVideoIndex: 0, // 当前视频索引
        isUploading: false, // 用于控制文件上传状态
    }
  },
  watch: {
    '$i18n.locale'() {
      this.fetchDefectCategoryOptions();
    }
  },
  mounted() {
    this.fetchDefectCategoryOptions();
  },
  computed: {
    currentTime() {
      const videoPlayer = this.$refs.videoPlayer;
      return videoPlayer ? this.formatTime(videoPlayer.currentTime) : '0:00';
    },
  },
  methods: {
    // 检查视频文件（不限制大小和格式）
    checkVideoFileFormat(file) {
      // 视频文件不做任何限制，直接返回 true
      // 使用 file 参数以避免 ESLint 警告
      console.log(`上传视频文件: ${file.name}`);
      return true;
    },
    // 递归函数来查找对应的 label
    findLabelByValue(options, value) {
      for (const option of options) {
        if (option.value === value) {
          return option.label;
        }
        if (option.children && option.children.length > 0) {
          const foundLabel = this.findLabelByValue(option.children, value);
          if (foundLabel) return foundLabel;
        }
      }
      return null; // 如果没有找到，返回 null
    },

    // formatter 方法
    formatDefectCategory(row, column, cellValue) {
      // 使用递归函数来获取 label
      const label = this.findLabelByValue(this.defectCategoryOptions, cellValue);
      return label || cellValue; // 如果找到了 label，则显示 label，否则显示原始 value
    },
    formatMotorAppearance(row, column, cellValue) {
      return cellValue === 1 ? this.$t('ApplyAfterSales.good') : this.$t('ApplyAfterSales.abnormal');
    },
    async fetchDefectCategoryOptions() {
      try {
        const treeData = this.transformToTree(this.defectCategorysData());
        this.defectCategoryOptions = this.transformDefectCateforysData(treeData);
      } catch (error) {
        console.error(this.$t('ApplyAfterSales.fetchDefectCategoriesFailed'));
      }
    },
    handleDialogClose() {
      this.faultDialogVisible = false;
      this.enableScroll();
    },
    async handleBeforeUploadInvoice(file) {
      // 调用公用文件大小检查函数
      if (!this.checkFileSize.call(this, file)) {
        return false; // 阻止上传
      }
      this.isUploading = true;
      try {
        // 例如使用 axios 手动上传文件
        const formData = new FormData();
        formData.append('file', file);
        const response = await uploadFileData(formData);
        if (response.code === 0) {
          // 处理成功的响应
          this.$message.success(this.$t('ApplyAfterSales.uploadSuccess'));
          // 假设后端响应包含文件的URL和名称
          const fileData = response;
          this.formData.invoiceFileList.push({
            name: fileData.fileName, // 文件名
            key: fileData.key, // 文件名
            url: fileData.url // 文件访问URL
          });
          // 更新用于提交给后端的 uploadedFile 字符串
          this.formData.invoiceUploadedFile = fileData.key; // 假设 response.key 是文件标识符
        } else {
          // 处理非200的响应
          this.$message.error(this.$t('ApplyAfterSales.uploadFailed'));
        }
      } catch (error) {
        // 处理异常
        this.$message.error(this.$t('ApplyAfterSales.uploadException'));
      } finally {
        this.isUploading = false;
      }
      return false;

    },
    async handleBeforeUploadSN(file) {
      // 调用公用文件大小检查函数
      if (!this.checkFileSize.call(this, file)) {
        return false; // 阻止上传
      }
      this.isUploading = true;
      try {
        // 例如使用 axios 手动上传文件
        const formData = new FormData();
        formData.append('file', file);

        const response = await uploadFileData(formData);
        if (response.code === 0) {
          // 处理成功的响应
          this.$message.success(this.$t('ApplyAfterSales.uploadSuccess'));
          // 假设后端响应包含文件的URL和名称
          const fileData = response;
          this.formData.SNFileList.push({
            name: fileData.fileName, // 文件名
            key: fileData.key, // 文件名
            url: fileData.url // 文件访问URL
          });
          // 更新用于提交给后端的 uploadedFile 字符串
          this.formData.SNUploadedFile = fileData.key; // 假设 response.key 是文件标识符
        } else {
          // 处理非200的响应
          this.$message.error(this.$t('ApplyAfterSales.uploadFailed'));
        }
      } catch (error) {
        // 处理异常
        this.$message.error(this.$t('ApplyAfterSales.uploadException'));
      } finally {
        this.isUploading = false;
      }
      return false;
    },
    async handleBeforeUploadVideo(file) {
      // 视频文件不限制大小，只检查文件格式
      if (!this.checkVideoFileFormat(file)) {
        return false; // 阻止上传
      }
      this.isUploading = true;
      try {
        // 例如使用 axios 手动上传文件
        const formData = new FormData();
        formData.append('file', file);

        const response = await uploadFileData(formData);

        if (response.code === 0) {
          // 处理成功的响应
          this.$message.success(this.$t('ApplyAfterSales.uploadSuccess'));
          // 假设后端响应包含文件的URL和名称
          const fileData = response;
          this.formData.videoFileList.push({
            name: fileData.fileName, // 文件名
            key: fileData.key, // 文件名
            url: fileData.url, // 文件访问URL
            status: 'success'
          });
          // 更新用于提交给后端的 uploadedFiles 字符串（逗号分隔）
          if (!this.formData.videoUploadedFiles || this.formData.videoUploadedFiles.trim() === '') {
            this.formData.videoUploadedFiles = fileData.key;
          } else {
            this.formData.videoUploadedFiles += ',' + fileData.key;
          }
          // 更新文件名列表
          this.formData.video_names.push(fileData.fileName);
          return true; // 返回 true 或不返回任何内容，以允许文件上传
        } else {
          // 处理非200的响应
          this.$message.error(this.$t('ApplyAfterSales.uploadFailed'));
          return false; // 阻止文件上传
        }
      } catch (error) {
        // 处理异常
        this.$message.error(this.$t('ApplyAfterSales.uploadException'));
        return false; // 阻止文件上传
      } finally {
        this.isUploading = false;
      }
    },
    async handleBeforeUploadImg(file) {
      // 调用公用文件大小检查函数
      if (!this.checkFileSize.call(this, file)) {
        return false; // 阻止上传
      }
      this.isUploading = true;
      try {
        // 例如使用 axios 手动上传文件
        const formData = new FormData();
        formData.append('file', file);

        const response = await uploadFileData(formData);
        if (response.code === 0) {
          // 处理成功的响应
          this.$message.success(this.$t('ApplyAfterSales.uploadSuccess'));
          const fileData = response;
          this.formData.imageFileList.push({
            name: fileData.fileName, // 文件名
            key: fileData.key,
            url: fileData.url, // 文件访问URL
            status: 'success'
          });
          // 更新用于提交给后端的 uploadedFiles 字符串（逗号分隔）
          if (!this.formData.imgUploadedFiles || this.formData.imgUploadedFiles.trim() === '') {
            this.formData.imgUploadedFiles = fileData.key;
          } else {
            this.formData.imgUploadedFiles += ',' + fileData.key;
          }
          // 更新文件名列表
          this.formData.image_names.push(fileData.fileName);
        } else {
          // 处理非200的响应
          this.$message.error(this.$t('ApplyAfterSales.uploadFailed'));
        }
      } catch (error) {
        // 处理异常
        this.$message.error(this.$t('ApplyAfterSales.uploadException'));
      } finally {
        this.isUploading = false;
      }
      return false;

    },
    async editItem(index) {
     
      this.faultDialogVisible = true;

      try {
        const faultInfoId = index.id;

        const faultInformation = await showAfterSalesDetails(faultInfoId);
        this.formData.fault_id = faultInformation.data.id;

        this.formData.materialCode = faultInformation.data.material_code;
        this.formData.SN = faultInformation.data.sn;

        this.formData.defectCategory = faultInformation.data.error_type;
        this.formData.motorAppearance = faultInformation.data.appearance_status;
        this.formData.defectDescription = faultInformation.data.description;

        // 处理SN标签文件展示
        const SNfileUrl = faultInformation.data.sn_label_url; // 从后端获取到的文件URL
        const SNfileName = faultInformation.data.sn_label_name; // 从后端获取到的文件名
        const SNUploadedFile = faultInformation.data.sn_label; // 获取文件key
        
        // 确保设置上传的文件key
        if (SNUploadedFile) {
          this.formData.SNUploadedFile = SNUploadedFile;
        }
        
        // 构建文件列表，添加key字段确保Element UI的upload组件能正确显示
        if ((SNfileUrl && SNfileUrl.trim()) || SNUploadedFile) {
          this.formData.SNFileList = [{
            name: SNfileName || SNUploadedFile.split('/').pop() || 'SN_Label', // 文件名，提供多种回退选项
            url: SNfileUrl?.trim() || '', // 文件URL，如果有的话
            status: 'success', // 标记为已上传
            key: SNUploadedFile || 'sn_label_key' // 关键：添加key字段
          }];
        }

        // 处理发票文件展示
        const invoiceUrl = faultInformation.data.invoice_url; // 从后端获取到的文件URL
        const invoiceName = faultInformation.data.invoice_name; // 从后端获取到的文件名
        const invoiceUploadedFile = faultInformation.data.invoice; // 获取文件key
        
        // 确保设置上传的文件key
        if (invoiceUploadedFile) {
          this.formData.invoiceUploadedFile = invoiceUploadedFile;
        }
        
        // 构建文件列表，添加key字段确保Element UI的upload组件能正确显示
        if ((invoiceUrl && invoiceUrl.trim()) || invoiceUploadedFile) {
          this.formData.invoiceFileList = [{
            name: invoiceName || invoiceUploadedFile.split('/').pop() || 'Invoice', // 文件名，提供多种回退选项
            url: invoiceUrl?.trim() || '', // 文件URL，如果有的话
            status: 'success', // 标记为已上传
            key: invoiceUploadedFile || 'invoice_key' // 关键：添加key字段
          }];
        }

        // 处理多图片展示
        this.formData.imageFileList = [];
        // 清理可能存在的开头逗号
        let imageKeyStr = faultInformation.data.image || '';
        if (imageKeyStr && imageKeyStr.startsWith(',')) {
          imageKeyStr = imageKeyStr.substring(1);
        }
        this.formData.imgUploadedFiles = imageKeyStr;
        
        // 从后端获取图片名称列表
        let imageNames = [];
        if (faultInformation.data.image_name) {
          try {
            // 尝试解析为数组
            imageNames = JSON.parse(faultInformation.data.image_name);
            // 如果解析后不是数组，创建一个包含该字符串的数组
            if (!Array.isArray(imageNames)) {
              imageNames = [imageNames];
            }
          } catch {
            // 如果解析失败，可能已经是逗号分隔的字符串
            imageNames = faultInformation.data.image_name.split(',');
          }
        }
        
        this.formData.image_names = imageNames;
        
        // 获取图片URL列表并构建文件列表 - 优化版本
        // 首先尝试直接使用image_url
        if (faultInformation.data.image_url) {
          const imageUrls = Array.isArray(faultInformation.data.image_url) 
            ? faultInformation.data.image_url 
            : faultInformation.data.image_url.split(',').filter(url => url.trim() !== '');
            
          imageUrls.forEach((url, i) => {
            if (url && url.trim()) {
              this.formData.imageFileList.push({
                name: imageNames[i] || `image_${i+1}`,
                url: url.trim(),
                status: 'success',
                key: imageKeyStr.split(',')[i] || `image_key_${i+1}`
              });
            }
          });
        } 
        // 如果没有image_url但有image字段，尝试获取签名URL
        else if (imageKeyStr) {
          const imageKeys = imageKeyStr.split(',').filter(key => key.trim() !== '');
          try {
            const imagePromises = imageKeys.map(async (key, index) => {
              try {
                const trimmedKey = key.trim();
                const signUrl = await getSignUrl(trimmedKey);
                return {
                  name: imageNames[index] || trimmedKey.split('/').pop() || `image_${index+1}`,
                  url: signUrl,
                  status: 'success',
                  key: trimmedKey
                };
              } catch (error) {
                console.error(`获取图片签名URL失败 (key: ${key}):`, error);
                // 即使获取签名URL失败，也添加到列表中，使用key作为回退
                return {
                  name: imageNames[index] || key.split('/').pop() || `image_${index+1}`,
                  url: '', // 空URL
                  status: 'success', // 标记为成功，以便显示在列表中
                  key: key.trim()
                };
              }
            });
            
            const imageFiles = await Promise.all(imagePromises);
            this.formData.imageFileList = imageFiles;
          } catch (error) {
            console.error('获取图片文件列表失败:', error);
          }
        }

        // 处理多视频展示
        this.formData.videoFileList = [];
        // 清理可能存在的开头逗号
        let videoKeyStr = faultInformation.data.video || '';
        if (videoKeyStr && videoKeyStr.startsWith(',')) {
          videoKeyStr = videoKeyStr.substring(1);
        }
        this.formData.videoUploadedFiles = videoKeyStr;
        
        // 从后端获取视频名称列表
        let videoNames = [];
        if (faultInformation.data.video_name) {
          try {
            // 尝试解析为数组
            videoNames = JSON.parse(faultInformation.data.video_name);
            // 如果解析后不是数组，创建一个包含该字符串的数组
            if (!Array.isArray(videoNames)) {
              videoNames = [videoNames];
            }
          } catch {
            // 如果解析失败，可能已经是逗号分隔的字符串
            videoNames = faultInformation.data.video_name.split(',');
          }
        }
        
        this.formData.video_names = videoNames;
        
        // 获取视频URL列表并构建文件列表 - 优化版本
        // 首先尝试直接使用video_url
        if (faultInformation.data.video_url) {
          const videoUrls = Array.isArray(faultInformation.data.video_url) 
            ? faultInformation.data.video_url 
            : faultInformation.data.video_url.split(',').filter(url => url.trim() !== '');
            
          videoUrls.forEach((url, i) => {
            if (url && url.trim()) {
              this.formData.videoFileList.push({
                name: videoNames[i] || `video_${i+1}`,
                url: url.trim(),
                status: 'success',
                key: videoKeyStr.split(',')[i] || `video_key_${i+1}`
              });
            }
          });
        }
        // 如果没有video_url但有video字段，尝试获取签名URL
        else if (videoKeyStr) {
          const videoKeys = videoKeyStr.split(',').filter(key => key.trim() !== '');
          try {
            const videoPromises = videoKeys.map(async (key, index) => {
              try {
                const trimmedKey = key.trim();
                const signUrl = await getSignUrl(trimmedKey);
                return {
                  name: videoNames[index] || trimmedKey.split('/').pop() || `video_${index+1}`,
                  url: signUrl,
                  status: 'success',
                  key: trimmedKey
                };
              } catch (error) {
                console.error(`获取视频签名URL失败 (key: ${key}):`, error);
                // 即使获取签名URL失败，也添加到列表中，使用key作为回退
                return {
                  name: videoNames[index] || key.split('/').pop() || `video_${index+1}`,
                  url: '', // 空URL
                  status: 'success', // 标记为成功，以便显示在列表中
                  key: key.trim()
                };
              }
            });
            
            const videoFiles = await Promise.all(videoPromises);
            this.formData.videoFileList = videoFiles;
          } catch (error) {
            console.error('获取视频文件列表失败:', error);
          }
        }
      } catch (error) {
        console.error(this.$t('ProductManage.loadDataFailed'));
        console.error(error);
      }
    },

    closeFaultDialog() {
      this.$refs.form.resetFields();
      // 重置多文件相关字段
      this.formData.imgUploadedFiles = '';
      this.formData.image_names = [];
      this.formData.videoUploadedFiles = '';
      this.formData.video_names = [];
      this.formData.imageFileList = [];
      this.formData.videoFileList = [];
      this.faultDialogVisible = false; // 取消按钮关闭弹框
    },

    async validateBeforeSave() {
      
      // 检查是否正在上传文件
      if (this.isUploading) {
        this.$message.warning(this.$t('ApplyAfterSales.uploadingFilePleaseWait') || '文件正在上传中，请稍等');
        return false;
      }
      
      // 进行表单校验
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          const fault_id = this.formData.fault_id;
          const formData = {
            material_code: this.formData.materialCode,
            sn: this.formData.SN,
            //sn_label: this.formData.SNFileList[0]?.name,
            sn_label: this.formData.SNUploadedFile,
            //invoice: this.formData.invoiceFileList[0]?.name,
            invoice: this.formData.invoiceUploadedFile,
            error_type: 1,
            appearance_status: this.formData.motorAppearance,
            // 确保没有开头多余的逗号
              image: (this.formData.imgUploadedFiles || '').replace(/^,+/, ''),
              image_name: JSON.stringify(this.formData.image_names),
              video: (this.formData.videoUploadedFiles || '').replace(/^,+/, ''),
            video_name: JSON.stringify(this.formData.video_names),
            description: this.formData.defectDescription,
            after_sale_id: this.id,
          };

          try {
            const response = await updateAfterSalesDetails(fault_id, formData);
            if (response.code === 0) {
              this.$message.success(this.$t('ApplyAfterSales.updateSuccess'));
              await this.loadData();
              this.faultDialogVisible = false;
              this.$refs.form.resetFields(); // 重置表单数据

            } else {
              this.$message.error(this.$t('ApplyAfterSales.updateFailed'));
            }
          } catch (error) {
            this.$message.error(this.$t('ApplyAfterSales.updateException'));
          }
        } else {
          this.$message.error(this.$t('ApplyAfterSales.formValidationFailed'));
        }
      });
    },

    async deleteItem(row) {
      try {
        await deleteAfterSalesDetails(row.id);
        await this.loadData();
      } catch (error) {
        // 处理错误，例如输出错误提示或进行其他处理
        console.error(this.$t('ProductManage.deleteDataFailed'));
      }
    },

    cancelDelete() {
      this.deleteDialogVisible = false;
    },
    confirmDelete() {
      // 确保 this.deleteIndex 是有效的索引
      if (this.deleteIndex !== null && this.deleteIndex >= 0 && this.deleteIndex < this.tableData.length) {
        // 创建一个本地的副本数组，避免直接修改父组件的 props
        const localTableData = [...this.tableData];

        // 在本地数组上进行删除操作
        localTableData.splice(this.deleteIndex, 1);
        // 将修改后的数据传递给父组件，可以使用 $emit 触发一个自定义事件
        this.$emit('update:tableData', localTableData);
      }

      //目前用前端删除的方法
      this.deleteIndex = null;
      this.deleteDialogVisible = false;
    },
    async showSNLabel(row) {
      // 处理SN Label URL
      let snLabelKeys = [];
      if (row.SNLabel) {
        // 如果有sn_label字段（key列表）
        snLabelKeys = row.SNLabel.split(',').filter(key => key.trim() !== '');
      } else if (row.sn_label_url) {
        // 兼容旧数据格式
        if (Array.isArray(row.sn_label_url)) {
          // 直接使用URL数组，取第一个
          this.imageUrl = row.sn_label_url[0];
        } else {
          // 直接使用单个URL
          this.imageUrl = row.sn_label_url;
        }
        // 如果已经有URL，不需要再调用接口
        if (this.imageUrl) {
          this.showImageDialog = true;
        } else {
          this.$message.warning('没有找到可用的SN Label图片');
        }
        return;
      }
      
      // 调用getSignUrl接口获取实际URL
      try {
        // 检查是否有有效的key
        if (snLabelKeys.length === 0) {
          this.$message.warning('没有找到可用的SN Label图片');
          return;
        }
        
        const snLabelPromises = snLabelKeys.map(async (key) => {
          try {
            const trimmedKey = key.trim();
            const result = await getSignUrl(trimmedKey);
            // 直接使用result作为URL，因为result本身就是URL字符串
            const url = typeof result === 'string' ? result : '';
            return url;
          } catch (error) {
            console.error(`获取SN Label图片URL失败 (key: ${key}):`, error);
            return '';
          }
        });
        
        const urls = await Promise.all(snLabelPromises);
        const validUrls = urls.filter(url => url !== '');
        
        if (validUrls.length > 0) {
          this.imageUrl = validUrls[0]; // SN Label取第一张
          this.showImageDialog = true;
        } else {
          this.$message.warning('没有找到可用的SN Label图片');
        }
      } catch (error) {
        console.error('加载SN Label图片失败:', error);
        this.$message.error('加载SN Label图片失败');
      }
    },
    async showInvoice(row) {
      // 处理发票URL
      let invoiceKeys = [];
      if (row.invoice) {
        // 如果有invoice字段（key列表）
        invoiceKeys = row.invoice.split(',').filter(key => key.trim() !== '');
      } else if (row.invoice_url) {
        // 兼容旧数据格式
        if (Array.isArray(row.invoice_url)) {
          // 直接使用URL数组，取第一个
          this.invoiceUrl = row.invoice_url[0];
        } else {
          // 直接使用单个URL
          this.invoiceUrl = row.invoice_url;
        }
        // 如果已经有URL，不需要再调用接口
        if (this.invoiceUrl) {
          this.invoiceVisible = true;
        } else {
          this.$message.warning('没有找到可用的发票图片');
        }
        return;
      }
      
      // 调用getSignUrl接口获取实际URL
      try {
        // 检查是否有有效的key
        if (invoiceKeys.length === 0) {
          this.$message.warning('没有找到可用的发票图片');
          return;
        }
        
        const invoicePromises = invoiceKeys.map(async (key) => {
          try {
            const trimmedKey = key.trim();
            const result = await getSignUrl(trimmedKey);
            // 直接使用result作为URL，因为result本身就是URL字符串
            const url = typeof result === 'string' ? result : '';
            return url;
          } catch (error) {
            console.error(`获取发票图片URL失败 (key: ${key}):`, error);
            return '';
          }
        });
        
        const urls = await Promise.all(invoicePromises);
        const validUrls = urls.filter(url => url !== '');
        
        if (validUrls.length > 0) {
          this.invoiceUrl = validUrls[0]; // 发票只有一张，取第一张
          this.invoiceVisible = true;
        } else {
          this.$message.warning('没有找到可用的发票图片');
        }
      } catch (error) {
        console.error('加载发票图片失败:', error);
        this.$message.error('加载发票图片失败');
      }
    },
    async showDefectImage(row) {
      // 处理图片URL
      let imageKeys = [];
      if (row.defectImages) {
        // 如果有defectImages字段（key列表）
        imageKeys = row.defectImages.split(',').filter(key => key.trim() !== '');
      } else if (row.image_url) {
        // 兼容旧数据格式
        if (Array.isArray(row.image_url)) {
          // 直接使用URL数组
          this.defectImages = row.image_url;
        } else {
          // 从逗号分隔字符串转换为数组
          this.defectImages = row.image_url.split(',').filter(url => url.trim() !== '');
        }
        // 如果已经有URL，不需要再调用接口
        if (this.defectImages.length > 0) {
          this.currentImageIndex = 0;
          this.defectImageUrl = this.defectImages[0];
          this.defectImageVisible = true;
        } else {
          this.$message.warning('没有找到可用的图片');
        }
        return;
      }
      
      // 调用getSignUrl接口获取实际URL
      try {
        // 检查是否有有效的key
        if (imageKeys.length === 0) {
          this.$message.warning('没有找到可用的图片');
          return;
        }
        
        const imagePromises = imageKeys.map(async (key) => {
          try {
            const trimmedKey = key.trim();
            const result = await getSignUrl(trimmedKey);
            // 直接使用result作为URL，因为result本身就是URL字符串
            const url = typeof result === 'string' ? result : '';
            return url;
          } catch (error) {
            console.error(`获取图片URL失败 (key: ${key}):`, error);
            return '';
          }
        });
        
        this.defectImages = await Promise.all(imagePromises);
        this.defectImages = this.defectImages.filter(url => url !== '');
        
        if (this.defectImages.length > 0) {
          this.currentImageIndex = 0;
          this.defectImageUrl = this.defectImages[0];
          this.defectImageVisible = true;
        } else {
          this.$message.warning('没有找到可用的图片');
        }
      } catch (error) {
        console.error('加载图片失败:', error);
        this.$message.error('加载图片失败');
      }
    },
    
    // 显示上一张图片
    showPreviousImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
        this.defectImageUrl = this.defectImages[this.currentImageIndex];
      }
    },
    
    // 显示下一张图片
    showNextImage() {
      if (this.currentImageIndex < this.defectImages.length - 1) {
        this.currentImageIndex++;
        this.defectImageUrl = this.defectImages[this.currentImageIndex];
      }
    },
    
    async showVideo(row) {
      // 处理视频URL
      let videoKeys = [];
      if (row.defectVideos) {
        // 如果有defectVideos字段（key列表）
        videoKeys = row.defectVideos.split(',').filter(key => key.trim() !== '');
      } else if (row.video_url) {
        // 兼容旧数据格式
        if (Array.isArray(row.video_url)) {
          // 直接使用URL数组
          this.defectVideos = row.video_url;
        } else {
          // 从逗号分隔字符串转换为数组
          this.defectVideos = row.video_url.split(',').filter(url => url.trim() !== '');
        }
        // 如果已经有URL，不需要再调用接口
        if (this.defectVideos.length > 0) {
          this.currentVideoIndex = 0;
          this.currentVideoUrl = this.defectVideos[0];
          this.videoDialogVisible = true;
        } else {
          this.$message.warning('没有找到可用的视频');
        }
        return;
      }
      
      // 调用getSignUrl接口获取实际URL
      try {
        // 检查是否有有效的key
        if (videoKeys.length === 0) {
          this.$message.warning('没有找到可用的视频');
          return;
        }
        
        const videoPromises = videoKeys.map(async (key) => {
          try {
            const trimmedKey = key.trim();
            const result = await getSignUrl(trimmedKey);
            // 直接使用result作为URL，因为result本身就是URL字符串
            const url = typeof result === 'string' ? result : '';
            return url;
          } catch (error) {
            console.error(`获取视频URL失败 (key: ${key}):`, error);
            return '';
          }
        });
        
        this.defectVideos = await Promise.all(videoPromises);
        this.defectVideos = this.defectVideos.filter(url => url !== '');
        
        if (this.defectVideos.length > 0) {
          this.currentVideoIndex = 0;
          this.currentVideoUrl = this.defectVideos[0];
          this.videoDialogVisible = true;
        } else {
          this.$message.warning('没有找到可用的视频');
        }
      } catch (error) {
        console.error('加载视频失败:', error);
        this.$message.error('加载视频失败');
      }
    },
    
    // 显示上一个视频
    showPreviousVideo() {
      if (this.currentVideoIndex > 0) {
        this.currentVideoIndex--;
        this.currentVideoUrl = this.defectVideos[this.currentVideoIndex];
        // 确保视频重新加载
        setTimeout(() => {
          const videoElement = this.$refs.videoPlayer;
          if (videoElement) {
            videoElement.load();
            videoElement.play();
          }
        }, 100);
      }
    },
    
    // 显示下一个视频
    showNextVideo() {
      if (this.currentVideoIndex < this.defectVideos.length - 1) {
        this.currentVideoIndex++;
        this.currentVideoUrl = this.defectVideos[this.currentVideoIndex];
        // 确保视频重新加载
        setTimeout(() => {
          const videoElement = this.$refs.videoPlayer;
          if (videoElement) {
            videoElement.load();
            videoElement.play();
          }
        }, 100);
      }
    },
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    
    // 通用文件下载方法
    downloadFile(url, defaultFileName) {
      if (!url) {
        this.$message.error(this.$t('ApplyAfterSales.downloadFailed'));
        return;
      }
      
      // 尝试从URL中提取文件名
      let fileName = defaultFileName;
      try {
        const urlParts = url.split('/');
        const lastPart = urlParts[urlParts.length - 1];
        if (lastPart.includes('.')) {
          fileName = lastPart.split('?')[0]; // 移除可能的查询参数
        }
      } catch (e) {
        console.error('Error extracting filename from URL:', e);
      }
      
      // 创建一个临时的a标签用于下载
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      
      // 对于跨域资源，需要先获取blob再下载
      if (url.startsWith('http') && !url.includes(window.location.hostname)) {
        fetch(url)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.blob();
          })
          .then(blob => {
            // 创建blob URL
            const blobUrl = URL.createObjectURL(blob);
            link.href = blobUrl;
            
            // 触发下载
            document.body.appendChild(link);
            link.click();
            
            // 清理
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
            
            this.$message.success(this.$t('ApplyAfterSales.downloadSuccess'));
          })
          .catch(error => {
            console.error('Error downloading file:', error);
            // 如果跨域下载失败，尝试直接下载
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
      } else {
        // 直接下载
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message.success(this.$t('ApplyAfterSales.downloadSuccess'));
      }
    },
  },

};
</script>

<style scoped>
:deep(.el-upload-list) {
  width: 500px;
}

:deep(.el-upload-list__item-name) {
  width: 300px;
}

.custom-tooltip-icon {
  margin-left: 8px; /* 在图标和标签文本之间添加一些空间 */
  cursor: pointer; /* 更明确地指示这是一个可以互动的图标 */
  font-size: 14px;
  color: black;
}

:deep( .custom-radio-group .el-radio__input.is-checked .el-radio__inner ) {
  border-color: rgb(0, 154, 68) !important;
  background-color: white !important;
}

:deep( .custom-radio-group .el-radio__input.is-checked .el-radio__inner::after ) {
  background-color: rgb(0, 154, 68) !important;
  width: 8px; /* 增加中间点的宽度 */
  height: 8px; /* 增加中间点的高度 */
  transform: translate(-50%, -50%); /* 确保点居中 */
}

:deep( .custom-radio-group .el-radio__label ) {
  color: rgb(38, 38, 38); /* 黑色 */
}

.custom-dialog-footer-padding .el-dialog__body {
  padding-bottom: 10px; /* 减少弹窗底部内边距，根据需要调整 */
}

:deep( .el-form-item__content ) {
  margin-top: 0; /* 减少内容顶部的外边距 */
}

:deep( .el-form-item__label ) {
  margin-bottom: 0; /* 减少label下方的外边距 */
  padding-bottom: 0; /* 减少label的内边距 */
}

.custom-input-width {
  width: 87%; /* 或其他您希望的宽度 */
}

.table-show {
  /* 样式 */
  margin: -25px 16px 16px 16px;
}

.video-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

/* 可以在这里定义表格的样式 */
</style>
